import { BaseExceptionApi } from '@/data/exceptions/BaseExceptionApi'

export class ExceptionApiGeneral extends BaseExceptionApi {
  constructor(message: string = '동작을 처리하던 도중 오류가 발생했습니다.') {
    super('ExceptionApiGeneral', 'GENERAL', message)
  }
}
